import { useMutation } from "@apollo/client/react";
import { CloseOutlined, UndoOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useTranslation } from "react-i18next";
import { DiscardDraftDocument } from "../../../gql/generated/graphqlSchema.tsx";
import { LoadingBlocker } from "../../../components/LoadingBlocker.tsx";
import { useRecipe } from "../RecipeContext.tsx";

type DiscardDraftButtonProps = {
  readonly onCompleted: () => void;
};

export const DiscardDraftButton = ({ onCompleted }: DiscardDraftButtonProps) => {
  const { t } = useTranslation();
  const { modal } = App.useApp();
  const { recipe } = useRecipe();
  const [discardDraft, { loading }] = useMutation(DiscardDraftDocument, { onCompleted });

  return (
    <>
      <LoadingBlocker loading={loading} />
      <Button
        danger
        icon={<UndoOutlined />}
        loading={loading}
        onClick={() =>
          modal.confirm({
            title: t("recipes.discardDraftTitle"),
            content: t("recipes.discardDraftConfirm"),
            okButtonProps: { danger: true, icon: <UndoOutlined /> },
            cancelButtonProps: { icon: <CloseOutlined /> },
            okText: t("recipes.discardDraft"),
            onOk: () => discardDraft({ variables: { id: recipe.id } }),
          })
        }
      >
        {t("recipes.discardDraft")}
      </Button>
    </>
  );
};
